import { z } from "zod";

export const LangChainToolCallChunkSchema = z.object({
  id: z.string(),
  name: z.string(),
  args: z.string(),
});

export const LangChainToolCallSchema = z.object({
  id: z.string(),
  name: z.string(),
  args: z.record(z.unknown()),
});

const MessageContentTextSchema = z.object({
  type: z.literal("text"),
  text: z.string(),
});

const MessageContentImageUrlSchema = z.object({
  type: z.literal("image_url"),
  image_url: z.union([z.string(), z.object({ url: z.string() })]),
});

const MessageContentToolUseSchema = z.object({
  type: z.literal("tool_use"),
});

const UserMessageContentComplexSchema = z.union([
  MessageContentTextSchema,
  MessageContentImageUrlSchema,
]);

const AssistantMessageContentComplexSchema = z.union([
  MessageContentTextSchema,
  MessageContentToolUseSchema,
]);

export const UserMessageContentSchema = z.union([
  z.string(),
  z.array(UserMessageContentComplexSchema),
]);

export const AssistantMessageContentSchema = z.union([
  z.string(),
  z.array(AssistantMessageContentComplexSchema),
]);

export const LangChainMessageSchema = z.discriminatedUnion("type", [
  z.object({
    id: z.string().optional(),
    type: z.literal("system"),
    content: z.string(),
  }),
  z.object({
    id: z.string().optional(),
    type: z.literal("human"),
    content: UserMessageContentSchema,
  }),
  z.object({
    id: z.string().optional(),
    type: z.literal("tool"),
    content: z.string(),
    tool_call_id: z.string(),
    name: z.string(),
  }),
  z.object({
    id: z.string().optional(),
    type: z.literal("ai"),
    content: AssistantMessageContentSchema,
    tool_call_chunks: z.array(LangChainToolCallChunkSchema).optional(),
    tool_calls: z.array(LangChainToolCallSchema).optional(),
  }),
]);

export type LangChainMessage = z.infer<typeof LangChainMessageSchema>;
export type UserMessageContent = z.infer<typeof UserMessageContentSchema>;
export type AssistantMessageContent = z.infer<
  typeof AssistantMessageContentSchema
>;
export type LangChainToolCallChunk = z.infer<
  typeof LangChainToolCallChunkSchema
>;
export type LangChainToolCall = z.infer<typeof LangChainToolCallSchema>;
